<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="500"
    :oneOption="false"
    :pendingOption="true"
    :sq_numberData="'sq_twentyFiveData'"
    :sqOptions="[]"
    :secondRadioB="false"
    @goBackInScoringHistory="goBackInScoringHistory">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'

export default {
  name: 'SQuesTwentyFive',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    setData () {
      this.$emit('handleProgress', 54)
    },
    goBackInScoringHistory () {
      this.$emit('goBackInScoringHistory')
    }
  },
  mounted () {
    this.setData()
  }
}
</script>
